import classNames from 'clsx';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { OK } from '../../../constants/localizations/app';
import Text from '../../Text';
import PillButton from '../button/PillButton';
import CommonDialog from './CommonDialog';
import css from './dialog.module.scss';

const OkDialog = ({
  shouldShow,
  handleClose,
  content,
  heading,
  bodyStyle,
  dialogContentStyle,
  dialogBodyClassName,
  dialogContentClassName,
  dataTestId,
  hideCornerClose = true,
  contentClassName,
}) => (
  <CommonDialog
    data-testid={dataTestId}
    key={dataTestId}
    dialogOpen={shouldShow}
    handleDialogClose={handleClose}
    classNames={{
      body: clsx(css.okDialogBody, dialogBodyClassName),
      content: clsx(css.okDialogContainer, dialogContentClassName),
      overlay: 'okDialogOverlay',
    }}
    styles={{
      body: bodyStyle,
      content: dialogContentStyle,
    }}
    maxWidth={420}
    hideCloseButton={hideCornerClose}
    preventOverlayClose
  >
    {heading}
    {content && (
      <div className={classNames(css.dialogContent, contentClassName)} data-testid="contentWrapper">
        {content}
      </div>
    )}
    <div>
      <PillButton
        className={css.button}
        id="dialogOkButton"
        dataTestId="dialogOkButton"
        label={<Text name={OK} />}
        onClick={handleClose}
        autoFocus
      />
    </div>
  </CommonDialog>
);

OkDialog.propTypes = {
  shouldShow: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  content: PropTypes.string,
  heading: PropTypes.node,
  dialogContentStyle: PropTypes.object,
  bodyStyle: PropTypes.object,
  dialogBodyClassName: PropTypes.string,
  dialogContentClassName: PropTypes.string,
  dataTestId: PropTypes.string.isRequired,
  hideCornerClose: PropTypes.bool,
  contentClassName: PropTypes.string,
};

export default OkDialog;
